<template>
  <Loader v-if="loading" />
  <div v-else>
    <div class="row analytics export-row">
      <div class="col-xs-12">
        <slot name="pdf_report" />
        <a
          class="pull-right btn btn-default pull-right-export"
          @click="download"
        ><span class="fa fa-download" />
          {{ trans('core.export') }}
        </a>
        <h4 v-if="lecturerFilter || courseFilter || categoryFilter">
          Filters
        </h4>
      </div>
      <div
        v-if="lecturerFilter"
        class="col-xs-3"
      >
        <p>{{ trans('core.lecturer') }}</p>
        <select
          v-model="lecturer"
          class="form-control"
          @change="getData()"
        >
          <option value="all">
            {{ trans('core.all') }}
          </option>
          <option
            v-for="(name, key) in filters.lecturers"
            :value="key"
          >
            {{ name }}
          </option>
        </select>
      </div>
      <div
        v-if="courseFilter"
        class="col-xs-3"
      >
        <p>{{ trans('core.course') }}</p>
        <select
          v-model="course"
          class="form-control"
          @change="getData()"
        >
          <option value="all">
            {{ trans('core.all') }}
          </option>
          <option
            v-for="(name, key) in filters.courses"
            :value="key"
          >
            {{ name }}
          </option>
        </select>
      </div>
      <div
        v-if="categoryFilter"
        class="col-xs-3"
      >
        <p>{{ trans('core.type') }}</p>
        <select
          v-model="category"
          class="form-control"
          @change="getData()"
        >
          <option value="all">
            {{ trans('core.all') }}
          </option>
          <option
            v-for="(name, key) in filters.categories"
            :value="key"
          >
            {{ name }}
          </option>
        </select>
      </div>
      <div class="col-xs-12">
        <hr>
      </div>
    </div>
    <div class="row analytics">
      <div v-if="questions == null || questions.length === 0">
        <div class="col-xs-12 text-center">
          <p>{{ trans('review.no_questions_found_with_feedback') }}</p>
        </div>
      </div>
      <div
        v-else
        class="table-analytics"
      >
        <div class="col-xs-12 table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th style="width:39%">
                  {{ trans_choice('core.questions',1) }}
                </th>
                <th style="width:15%">
                  {{ trans('review.occurrences') }}
                </th>
                <th style="width:15%">
                  {{ trans('review.average_response_rate') }}
                </th>
                <th style="width:30%">
                  {{ trans('review.answer') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="question in this.questions">
                <tr>
                  <td
                    class="hand"
                    @click="showDetailed(question)"
                  >
                    <a>
                      <span
                        class="fa"
                        :class="detailed[question.id] ? 'fa-chevron-down' : 'fa-chevron-right'"
                      />
                      {{ question.question }}
                    </a>
                  </td>
                  <td>{{ question.used }}</td>
                  <td>
                    <span
                      data-toggle="tooltip"
                      :title="question.responses.responses + ' / ' + question.responses.total"
                    > {{ question.responses.percentage }}</span>
                  </td>
                  <td>
                    <template v-if="question.type == 'like'">
                      <like-question-result-bar
                        :question="question"
                        :answers="question.answers.data"
                      />
                    </template>
                    <template v-else-if="question.type == 'five_scale'">
                      <five-scale-question-result-bar
                        :question="question"
                        :answers="question.answers.data"
                      />
                    </template>
                    <template v-else-if="question.type == 'ten_scale'">
                      <ten-scale-question-result-bar
                        :question="question"
                        :answers="question.answers.data"
                      />
                    </template>
                    <template v-else-if="question.type == 'six_scale'">
                      <six-scale-question-result-bar
                        :question="question"
                        :answers="question.answers.data"
                      />
                    </template>
                    <template v-else-if="question.type == 'select_one'">
                      <select-one-question-result-bar
                          :question="question"
                          :answers="question.answers.data"
                      />
                    </template>
                  </td>
                </tr>
                <tr v-if="detailed[question.id]">
                  <td colspan="4">
                    <table
                      class="table"
                      style="background-color:inherit"
                    >
                      <Loader v-if="loadingEvents[question.id]" />
                      <template v-else>
                        <tr>
                          <th style="width:39%">
                            {{ trans('core.name') }}
                          </th>
                          <th style="width:15%">
                            {{ trans_choice('core.lecturers',2) }}
                          </th>
                          <th style="width:15%">
                            {{ trans('review.response_rate') }}
                          </th>
                          <th style="width:30%">
                            {{ trans_choice('core.answers',2) }}
                          </th>
                        </tr>
                        <tr v-for="event in question.events.data">
                          <td style="width:39%">
                            <slot
                              name="event_link"
                              :event="event"
                              :questionId="question.id"
                            /> ({{ event.date }})
                          </td>
                          <td style="width:15%">
                            {{ event.lecturers }}
                          </td>
                          <td style="width:15%">
                            <span
                              data-toggle="tooltip"
                              :title="event.responses + ' / ' + event.total"
                            > {{ event.response_rate }}</span>
                          </td>
                          <td style="width:30%">
                            <template v-if="question.type == 'like'">
                              <like-question-result
                                :has-margin="false"
                                :answers="event.answers.data"
                              />
                            </template>
                            <template v-else-if="question.type == 'five_scale'">
                              <five-scale-question-result
                                :has-margin="false"
                                :answers="event.answers.data"
                              />
                            </template>
                            <template v-else-if="question.type == 'ten_scale'">
                              <ten-scale-question-result
                                :has-margin="false"
                                :answers="event.answers.data"
                              />
                            </template>
                            <template v-else-if="question.type == 'six_scale'">
                              <six-scale-question-result
                                :has-margin="false"
                                :answers="event.answers.data"
                              />
                            </template>
                            <template v-else-if="question.type == 'open'">
                              <open-question-result-modal
                                :event="event"
                                :answers="event.answers.data"
                                :question="question"
                              />
                            </template>
                            <template v-else-if="question.type == 'select_one'">
                              <select-one-question-result
                                  :event="event"
                                  :answers="event.answers.data"
                                  :question="question"
                              />
                            </template>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Loader v-if="loadingAdditionalData" />
    <template v-else-if="hasMoreData">
      <div
        class="additional-data"
        @click="getAdditionalData"
      >
        {{ trans('subscription.load_more') }}
      </div>
    </template>
  </div>
</template>

<script>
import LikeQuestionResultBar from './LikeQuestionResultBar'
import LikeQuestionResult from '../results/students/LikeQuestionResult'
import FiveScaleQuestionResult from '../results/students/FiveScaleQuestionResult'
import FiveScaleQuestionResultBar from './FiveScaleQuestionResultBar'
import SelectOneQuestionResultBar from './SelectOneQuestionResultBar'
import SelectOneQuestionResult from '../results/students/SelectOneQuestionResult'
import OpenQuestionResultModal from './OpenQuestionResultModal'
import TenScaleQuestionResult from '../results/students/TenScaleQuestionResult'
import TenScaleQuestionResultBar from './TenScaleQuestionResultBar'
import SixScaleQuestionResult from '../results/students/SixScaleQuestionResult'
import SixScaleQuestionResultBar from './SixScaleQuestionResultBar'
import { defaultErrorMessage } from '@/helpers'
import Vue from 'vue'
import { api } from '@/lti/api'
import axios from 'axios'

export default {
  name: 'QuestionAggregationViewRaw',
  components: {
    SixScaleQuestionResult,
    SixScaleQuestionResultBar,
    TenScaleQuestionResultBar,
    TenScaleQuestionResult,
    LikeQuestionResult,
    FiveScaleQuestionResult,
    LikeQuestionResultBar,
    FiveScaleQuestionResultBar,
    OpenQuestionResultModal,
    SelectOneQuestionResultBar,
    SelectOneQuestionResult,
  },

  props: {
    campaign: { required: false, default: null },
    own: { type: Boolean, required: false, default: false },
    filters: { required: false, default: null },
    lecturerFilter: { type: Boolean, required: false, default: false },
    categoryFilter: { type: Boolean, required: false, default: false },
    courseFilter: { type: Boolean, required: false, default: false },
    questions: { required: false, default: null },
    loading: { required: true, type: Boolean },
    dataUrl: { type: String, required: true },
    hasMoreData: { required: true, type: Boolean },
    loadingAdditionalData: { required: true, type: Boolean },
    lti: {required: true, type: Boolean},
    course: {required: false, type: String, default: 'all'}
  },

  data () {
    return {
      detailed: [],
      detailed2: false,
      lecturer: 'all',
      category: 'all',
      loadingEvents: [],
    }
  },

  computed: {
    dataParams () {
      return {
        course: this.course,
        lecturer: this.lecturer,
        category: this.category,
        campaign: this.campaign,
        own: this.own,
      }
    },

    showFilters () {
      return this.lecturerFilter || this.courseFilter || this.categoryFilter
    },
    api (){
      if(this.lti){
        return api
      }
      return axios
    }
  },

  watch: {
    questions: function () {
      for (let question in this.questions) {
        this.detailed[this.questions[question].id] = false
      }
    },
  },

  mounted () {
    this.$emit('fetchData', this.dataParams)
  },

  methods: {

    getData () {
      this.$emit('getData', this.dataParams)
    },

    getAdditionalData () {
      this.$emit('getAdditionalData', this.dataParams)
    },

    showDetailed (question) {
      if (this.detailed[question.id] === false) {
        Vue.set(this.detailed, question.id, true)

        if (question.events == null) {
          Vue.set(this.loadingEvents, question.id, true)

          this.api.get(this.dataUrl, {
            params: {
              course: this.course,
              lecturer: this.lecturer,
              category: this.category,
              campaign: this.campaign,
              own: this.own,
              question: question.id,
              include: ['events'],
            },
          }).then(({ data }) => {
            question['events'] = data.data[0].events
            Vue.set(this.loadingEvents, question.id, false)
          }).catch(error => defaultErrorMessage(error))
        }
      } else {
        Vue.set(this.detailed, question.id, false)
      }
    },
    download () {
      this.$emit('download', this.dataParams)
    },
  },
}
</script>

<style scoped>
    .hand {
        cursor: pointer;
    }
    .additional-data {
      margin-top: 10px;
      text-align: center;
      font-weight: bold;
      cursor: pointer;
    }
</style>
